import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import HomePage from './pages/HomePage';
import DatenschutzPage from './pages/DatenschutzPage';
import ImpressumPage from './pages/ImpressumPage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#000000', // Dunkelblau für Corps-Farben
      white: '#FFFFFF',
      green: '#45592a', // Dunkelgrün
      beige: '#cfba80', // Beige
    },
    secondary: {
      main: '#DAA520', // Gold
    },
    background: {
      default: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"TASAOrbiter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Magnolia", serif',
      fontWeight: 500,
    },
    h2: {
      fontFamily: '"Magnolia", serif',
      fontWeight: 600,
    },
    h3: {
      fontFamily: '"Magnolia", serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Magnolia", serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"TASAOrbiter", sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"TASAOrbiter", sans-serif',
      fontWeight: 500,
    },
    body1: {
      fontFamily: '"TASAOrbiter", sans-serif',
    },
    body2: {
      fontFamily: '"TASAOrbiter", sans-serif',
    },
    button: {
      fontFamily: '"TASAOrbiter", sans-serif',
      fontWeight: 600,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
